import React                 from "react";
import { AlertBox, RefluxComponent } from "sp-react-commons";
import { last as _last, split as _split } from "lodash";

import { GroupApi }          from "../../api/Api";

import { ValidationSubmit, ValidationField } from "react-validation";
import  Modal             from "react-bootstrap/lib/Modal";
 import { CommonsConstants }      from "../../../commons";
import { Translation, MywortModalWrapper, UserStore }           from "../../../commons";

import userModule4 from "../../../../../images/usermodule/_04.png";


const PANEL_TYPES = {
    JOIN: "Join",
    JOIN_REQUESTED: "JoinRequested",
    OWNERSHIP: "Ownership"
};

export default class JoinGroupRequest extends RefluxComponent {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            user: {},
            groupName: "",
            panelType: "",
            comment: Translation.translate("public.join-group-request.modal.comments-to-owner"),
            groupId: _last(_split(window.location.href, "/")) // Extract group id from latest part of the url
        };

        this.listenTo(UserStore, this.onRefreshUser);
    }

    onRefreshUser = (data) => {
        if(data && data.user) {
            GroupApi.getGroup(this.state.groupId).then( (group) => {
                // TODO RCH : hide-group-feature
                if(group.status === "active") {
                    GroupApi.getJoinRequest(this.state.groupId).then( (groupRequest) => {
                        if(groupRequest && groupRequest.status === "")
                            this.setState({ panelType: PANEL_TYPES.JOIN });
                        else if(groupRequest && groupRequest.status === CommonsConstants.JOIN_REQUEST_STATUS.REQUESTED)
                            this.setState({ panelType: PANEL_TYPES.JOIN_REQUESTED });
                    });
                } else if(group.status === "inactive_owner") {
                   this.setState({ panelType: PANEL_TYPES.OWNERSHIP, groupName: group.name, user: data.user});
               }
            });
        }
    };

    onChangeComment = (value) => this.setState({ comment: value });
    onClickJoinGroup = () => this.setState({ show: true });
    onHide = () => this.setState({ show: false });

    onSubmit = (errors) => {
        if(!errors) {
            let joinRequest = {
                groupId: this.state.groupId,
                //groupName: this.state.groupName,
                comment: this.state.comment
            };
            GroupApi.createJoinGroupRequest(joinRequest).then(() => window.location.reload());
        }
    };

    onClickGroupOwnership = () => {
        window.location.href="mailto:contact@mywort.lu?subject=" + Translation.translate("public.group-ownership-request.email-subject") + "[" + this.state.user.id + "]"
            + "&body="  + Translation.translate("public.group-ownership-request.email-body", {"groupName" : this.state.groupName, "ownerName" : this.state.user.firstName + " " + this.state.user.lastName });
    };

    renderToJoinPanel = () => (
        <div>
            <MywortModalWrapper show={this.state.show} onHide={this.onHide} className="mywort-group-request-modal" backdrop>
                <Modal.Header className="mywort-modal__header" closeButton>
                    <Modal.Title className="mywort-modal__title">{Translation.translate("public.join-group-request.modal.title")}</Modal.Title>
                </Modal.Header>
                <AlertBox autoScroll
                          defaultMessage={Translation.translate("alert-box.default-message")}
                          reloadMessage={Translation.translate("alert-box.reload-message")}
                          class="mywort-alert-box mywort-alert-box--inline"
                          alertClasses={{
                              "DEFAULT": "mywort-alert-box--default",
                              "SUCCESS": "mywort-alert-box--success",
                              "INFO": "mywort-alert-box--info",
                              "WARNING": "mywort-alert-box--warning",
                              "ERROR": "mywort-alert-box--error"
                          }}
                />
                <Modal.Body>
                    <ValidationField name="comment" rules={{ required: true }}>
                        <textarea className="mywort-modal__join-group-request-comment" value={this.state.comment} onChange={this.onChangeComment} disabled={this.state.success} rows={4} maxLength="200"/>
                    </ValidationField>
                </Modal.Body>
                <Modal.Footer className="mywort-modal__footer">
                    <button className="mywort-btn mywort-btn--transparent-gray" onClick={this.onHide}>{Translation.translate("commons.close")}</button>
                    <ValidationSubmit onSuccess={this.onSubmit} className="mywort-btn u-text-uppercase">{Translation.translate("commons.submit")}</ValidationSubmit>
                </Modal.Footer>
            </MywortModalWrapper>

            <div className="info-container info-container--orange">
                <div className="info-container__content">
                    <div className="info-container__content__left"><img src={userModule4} /></div>
                    <div className="info-container__content__right">
                        <div className="info-container__content__right__title">{Translation.translate("public.join-group-request.become-maintainer")}</div>
                        <div className="info-container__content__right__desc"> {Translation.translate("public.join-group-request.join-group-message")}</div>
                        <div className="text-center info-container__content__btn">
                            <button className="mywort-btn mywort-btn--invert-orange mywort-btn--radius" onClick={this.onClickJoinGroup}>{Translation.translate("public.join-group-request.want-join-group")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    renderAlreadyJoinedPanel = () => (
        <div className="info-container info-container--orange">
            <div className="info-container__content">
                <div className="info-container__content__left"><img src={userModule4} /></div>
                <div className="info-container__content__right info-container__content__right--already-joined">
                    <div className="info-container__content__right__title">{Translation.translate("public.join-group-request.already-did-request")}</div>
                    <div className="info-container__content__right__desc">{Translation.translate("public.join-group-request.wait-for-validation")}</div>
                </div>
            </div>
        </div>
    );

    renderOwnershipPanel = () => (
        <div className="info-container info-container--orange">
            <div className="info-container__content">
                <div className="pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24">
                    <div className="row">
                        <div className="pure-u-1 info-container__content__left pure-u-lg-6-24 pure-u-md-6-24 pure-u-sm-24-24"><img src={userModule4} /></div>
                        <div className="pure-u-1 info-container__content__right pure-u-lg-18-24 pure-u-md-18-24 pure-u-sm-24-24">
                            <div className="info-container__content__right__title">{Translation.translate("public.group-ownership-request.become-owner")}</div>
                            <div className="info-container__content__right__desc">{Translation.translate("public.group-ownership-request.group-ownership-message")}</div>
                        </div>
                    </div>
                </div>
                <div className="pure-u-1 pure-u-md-4-24 pure-u-lg-4-24 pure-u-sm-24-24 text-center info-container__content__btn">
                    <button className="mywort-btn mywort-btn--invert-orange mywort-btn--radius" onClick={this.onClickGroupOwnership}>{Translation.translate("public.group-ownership-request.want-to-own")}</button>
                </div>
            </div>
        </div>
    );

    render = () => {
        if (this.state.panelType === PANEL_TYPES.JOIN)
            return this.renderToJoinPanel();
        else if (this.state.panelType === PANEL_TYPES.JOIN_REQUESTED)
            return this.renderAlreadyJoinedPanel();
        else if (this.state.panelType === PANEL_TYPES.OWNERSHIP)
            return this.renderOwnershipPanel();
        else
            return null;
    };

}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/joinGroupRequest/JoinGroupRequest.jsx